import { animateEmissiveColor } from "./script.js";
import {
  uiModel,
  step1,
  step2,
  step3,
  gltfObject,
  lastScene,
  youwill,
} from "./uiScene.js";
let isLastSceneTriggered = !1;
const baseUrl = "https://www.thedeath.xyz/";
var bless = new Audio("/sfx.mp3");
(bless.loop = !0),
  document.addEventListener("click", () => {
    bless.paused && bless.play();
  });
export async function connectTwitter() {
  bless.paused && bless.play();
}
export async function checkAuthStatus(t, e) {
  try {
  } catch (t) {}
}
export async function fetchDeathReason() {
  try {
    const t = await fetch("/api/get-death-reason", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
    });
    if (!t.ok) throw new Error("Failed to fetch death reason");
    return (await t.json()).reason || "mysterious circumstances";
  } catch (t) {
    return "mysterious circumstances";
  }
}
export function setupSacrificeButton() {
  bless.paused && bless.play();
  const t = `https://twitter.com/intent/tweet?text=${encodeURIComponent(
    "When will my end come? @DEATHdotfun #DEATHdotfun"
  )}`;
  if (/iPhone|iPad|iPod|Android/i.test(navigator.userAgent))
    window.location.href = t;
  else {
    const e = 600,
      n = 400,
      s = (screen.width - e) / 2,
      o = (screen.height - n) / 2;
    window.open(
      t,
      "TweetWindow",
      `width=${e},height=${n},top=${o},left=${s},toolbar=no,menubar=no,scrollbars=no,resizable=no,status=no`
    );
  }
}
export function triggerAnimation() {
  setTimeout(() => {
    const t = document.getElementById("tweet-step");
    t && (t.classList.add("fade-in"), (t.style.visibility = "visible"));
  }, 5e3),
    fetchDeathReason().then((t) => {
      const e = document.getElementById("death-reason-text");
      e && (e.innerHTML = t);
    }),
    uiModel && lastScene(uiModel, step1, step3, gltfObject, youwill),
    animateEmissiveColor("#FF0000");
}
function getCookie(t) {
  const e = `; ${document.cookie}`.split(`; ${t}=`);
  return 2 === e.length ? e.pop().split(";").shift() : null;
}
document.addEventListener("DOMContentLoaded", function () {
  const t = document.getElementById("tweetCheck"),
    e = document.getElementById("check-button");
  t.addEventListener("submit", async function (t) {
    if ((t.preventDefault(), e.disabled)) return;
    const n = (function () {
      const t = document.getElementById("tweet_url_1").value.trim();
      if (!t) return null;
      let e = t;
      return (
        e.startsWith("http://") ||
          e.startsWith("https://") ||
          (e = "https://" + e),
        e.match(/^https?:\/\/x\.com\/([A-Za-z0-9_]+)\/status\/(\d+)(?:\?.*)?$/)
          ? e
          : null
      );
    })();
    if (!n) return;
    const s = (function (t) {
        const e = t.match(
          /^https?:\/\/x\.com\/([A-Za-z0-9_]+)\/status\/(\d+)(?:\?.*)?$/
        );
        return e ? e[1] : null;
      })(n),
      o = getCookie("username");
    if (o && s === o) {
      try {
        (
          await fetch("/api/save-tweet-url", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ tweet_url: n }),
          })
        ).ok;
      } catch (t) {}
      (document.getElementById("tweet-step").style.visibility = "hidden"),
        uiModel && lastScene(uiModel, step2, step3, gltfObject, youwill),
        animateEmissiveColor("#FF0000"),
        bless.paused && bless.play(),
        document.getElementById("tweet-step").classList.add("none");
    }
  });
}),
  document.addEventListener("DOMContentLoaded", function () {
    document
      .getElementById("ref-twitter")
      .addEventListener("click", function () {
        window.open("https://x.com/168_onesixeight", "_blank");
      });
  });
